module.exports = __webpack_public_path__ + "static/media/design_development.ce142c08.svg";